import React from 'react';

import ControlConnectionErrorIcon from '@/comp/common/icons/ControlConnectionErrorIcon';
import ControlControlledIcon from '@/comp/common/icons/ControlControlledIcon';
import ControlOnOffIcon from '@/comp/common/icons/ControlOnOffIcon';
import ControlUnknownIcon from '@/comp/common/icons/ControlUnknownIcon';
import ControlWarningIcon from '@/comp/common/icons/ControlWarningIcon';
import { ControlModeEnum, DeviceConnectivity } from '@/constants/enums';
import { toTranslationFormat } from '@/utils/util-functions';

export enum MessageSeverityLevels {
  Default = 0,
  Info = 1,
  Warning = 2,
  Error = 3,
}

export const getPopoverContent = (connectivity, selectedMessage, controlMode, t) => {
  if (
    selectedMessage.severityLevel >= MessageSeverityLevels.Info &&
    selectedMessage.severityLevel <= MessageSeverityLevels.Error
  ) {
    return selectedMessage.text;
  }

  switch (connectivity) {
    case DeviceConnectivity.NoState:
      return t('No State');
    case DeviceConnectivity.Connected:
      return t('Connected');
    case DeviceConnectivity.Disconnected:
      return t('CONNECTION_ERROR');
  }

  return t(toTranslationFormat(controlMode));
};

export const getIcon = (connectivity, controlMode, severityLevel, rest, token) => {
  switch (connectivity) {
    case DeviceConnectivity.NoState:
      return <ControlUnknownIcon {...rest} />;
    case DeviceConnectivity.Disconnected:
      return <ControlConnectionErrorIcon {...rest} />;
  }

  switch (severityLevel) {
    case MessageSeverityLevels.Error:
      return <ControlWarningIcon color={token.colorError} {...rest} />;
    case MessageSeverityLevels.Warning:
      return <ControlWarningIcon {...rest} />;
  }

  switch (controlMode) {
    case ControlModeEnum.Controllable:
      return <ControlControlledIcon {...rest} />;
    case ControlModeEnum.OnOff:
      return <ControlOnOffIcon {...rest} />;
    case ControlModeEnum.NotControllable:
      return <ControlControlledIcon color={token.colorBgMask} {...rest} />;
  }
};
